import { BlogApi } from '@sportheroes/oly-engine-api';

import { olyEngineApi } from './Config/olyEngineApi';

const { BLOG_API_URL } = process.env;

export default new BlogApi(BLOG_API_URL, {}, olyEngineApi);
